// extracted by mini-css-extract-plugin
export default {"root":"root--4963061","row":"row--ebd1648","status":"status--ce76d7d","text":"text--fab7b68","refusal":"refusal--5c23d1e"};